import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Modal,
  Card,
  ModalBody,
  CardBody,
  Col,
  Container,
  Row,
  ModalHeader,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
} from "reactstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ErrorModal,
  RavenAgSelectable,
  RavenAgTable,
  WarningModal,
  MessageBoxModal
} from "components/Common/CombinedComponents";
import {
  getBooleanValueCheckbox,
  getInitValue,
  getInitValueBoolean,
  getInitValueNull,
  getListItemParameter,
  getTitleValue,
  getListItemParameterExcelExport
} from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";
import classnames from "classnames";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import { getCardBrandDefList, getCardTypeDefList, getApiKeyByMerchantId, getUserByUserName, getUserEncKeyByMerchantGuid, doPaymentSignVoid, doPaymentSignRefund, getCurrencyList, getDomesticBankList, getPayOutStatusDefList, getPosEntryModeList, getRavenAuthorizationResponseCodeDefList, getRavenTransactionTypeDefList, getTerminalDefList, getTransactionNetworkDefList, getTransactionProvisionSettleList, getTransactionSourceDefList, transactionProvisionSettleApiError, getTransactionProvisionList, getTransactionInstallmentTypeDefList, getProvisionStatusDefList, getCountryList, getMerchantPaymentDetailByTransactionProvisionSettleGuid, doPaymentApiError } from "store/actions";
import { Formik } from "formik";
import RavenFormikField from "components/Common/RavenFormikField";
import TransactionMonitoringBoxSingle from "./TransactionMonitoringBoxSingle";
import SearchContentTransactionProvisionSettle from "./SearchContentTransactionProvisionSettle";
import SearchContentTransactionProvision from "./SearchContentTransactionProvision";
import DoPaymentRefundOperations from "./doPaymentRefundOperations";
import DoPaymentVoidOperation from "./doPaymentVoidOperation";
import moment from "moment";

class transactionMonitoring extends Component {

  constructor(props) {
    super(props);

    this.state = {secureLevels: [
      {
        guid: 0,
        desc: "None Secure"
      },
      {
        guid: 1,
        desc: "Half Secure"
      },
      {
        guid: 2,
        desc: "Full Secure"
      }
    ],
      recordList: [],
      modal: false,
      modalSettle: false,
      doPaymentMessage:false,
      doPaymentResponseMessageDetail:"",
      record: "",
      errorModal: false,
      activeTab: "1",
      activeTabDetail: "1",
      activeTabDetailSettle: "1",
      isDetail: false,
      cancelModal: false,
      warningModal: false,
      selectedDataList: [],
      transactionCodes: [{
        code: "Iade - Esleniksiz"
      },
      {
        code: "Iade - Eslenikli"
      },
      {
        code: "Finansal Bakim ÜIY Alacak"
      },
      {
        code: "Finansal Bakim ÜIY Borç"
      },
      {
        code: "CB Iade"
      },
      {
        code: "CB Satis"
      }],
      randomString: '',
      refundModal: false,
      recordcolumnsTransactionProvision: [
        {
          headerName: this.props.t("transactionDate"),
          field: "insertDateTime"
        },
        {
          headerName: this.props.t("orderId"),
          field: "orderId",
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("paymentId"),
          field: "paymentId",
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("bankUniqueReferenceNumber"),
          field: "bankUniqueReferenceNumber",
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("transactionNetworkGuid"), field: "transactionNetworkGuid",
          valueFormatter: params => getListItemParameter(params, this.props.transactionNetworkDefRecordList, "description"),
          valueGetter: params => getListItemParameterExcelExport(params.data.transactionNetworkGuid, this.props.transactionNetworkDefRecordList, "description") || params.data.transactionNetworkGuid,
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("ravenAuthorizationResponseCodeGuid"),
          field: "ravenAuthorizationResponseCodeGuid",
          valueFormatter: params => getListItemParameter(params, this.props.ravenAuthorizationResponseCodeDefRecordList, "description"),
          filterParams: {
            valueFormatter: params =>
              getListItemParameter(params, this.props.ravenAuthorizationResponseCodeDefRecordList, "description"),
          },
          valueGetter: params => getListItemParameterExcelExport(params.data.ravenAuthorizationResponseCodeGuid, this.props.ravenAuthorizationResponseCodeDefRecordList, "description") || params.data.ravenAuthorizationResponseCodeGuid,
          cellClass: 'stringType'
        },
        {
          headerName: this.props.t("transactionType"), field: "ravenTransactionTypeGuid",
          valueFormatter: params => getListItemParameter(params, this.props.ravenTransactionTypeDefRecordList, "description"),
          valueGetter: params => getListItemParameterExcelExport(params.data.ravenTransactionTypeGuid, this.props.ravenTransactionTypeDefRecordList, "description") || params.data.ravenTransactionTypeGuid,
          cellClass: 'stringType'
        },
        {
          headerName: this.props.t("cardNo"),
          field: "cardNo"
        },
        {
          headerName: this.props.t("cardTypeGuid"), field: "cardTypeGuid",
          valueFormatter: params => getListItemParameter(params, this.props.cardTypeRecordList, "description"),
          valueGetter: params => getListItemParameterExcelExport(params.data.cardTypeGuid, this.props.cardTypeRecordList, "description") || params.data.cardTypeGuid,
          cellClass: 'stringType'
        },
        {
          headerName: this.props.t("provisionStatusName"), field: "provisionStatusGuid",
          valueFormatter: params => getListItemParameter(params, this.props.provisionStatusDefRecordList, "name"),
          valueGetter: params => getListItemParameterExcelExport(params.data.provisionStatusGuid, this.props.provisionStatusDefRecordList, "name") || params.data.provisionStatusGuid,
          cellClass: 'stringType'
        },
        {
          headerName: this.props.t("preAuthAmount"),
          field: "preAuthAmount"
        },
        {
          headerName: this.props.t("installmentTypeGuid"), field: "installmentTypeGuid",
          valueFormatter: params => getListItemParameter(params, this.props.transactionInstallmentTypeRecordList, "description"),
          valueGetter: params => getListItemParameterExcelExport(params.data.installmentTypeGuid, this.props.transactionInstallmentTypeRecordList, "description") || params.data.installmentTypeGuid,
          cellClass: 'stringType'
        },
        {
          headerName: this.props.t("installmentCount"),
          field: "installmentCount"
        },
        {
          headerName: this.props.t("transactionAmount"),
          field: "f004"
        },
        {
          headerName: this.props.t("settlementAmount"),
          field: "f005"
        },
        {
          headerName: this.props.t("transactionDate"),
          field: "f013"
        },
        {
          headerName: this.props.t("posEntryMode"), field: "posEntryModeGuid",
          valueFormatter: params => getListItemParameter(params, this.props.posEntryModeRecordList, "description"),     
          valueGetter: params => getListItemParameterExcelExport(params.data.posEntryModeGuid, this.props.posEntryModeRecordList, "description") || params.data.posEntryModeGuid,
          cellClass: 'stringType'
        },
        {
          headerName: this.props.t("bankName"), field: "bankGuid",
          valueFormatter: params => getListItemParameter(params, this.props.domesticBankRecordList, "bankName"),
          valueGetter: params => getListItemParameterExcelExport(params.data.bankGuid, this.props.domesticBankRecordList, "bankName") || params.data.bankGuid,
          cellClass: 'stringType'
        },
        {
          headerName: this.props.t("authorizationNumber"),
          field: "f038"
        },
        {
          headerName: this.props.t("terminalId"),
          field: "f041"
        },
        {
          headerName: this.props.t("cardAcceptorName"),
          field: "f043cardAcceptorName"
        },
        {
          headerName: this.props.t("cardAcceptorCityName"),
          field: "f043cardAcceptorCityName"
        },
        {
          headerName: this.props.t("cardAcceptorCountryCode"),
          field: "f043cardAcceptorCountryCode",
          valueFormatter: params => this.getNameByNumericCode(params, this.props.countryDefinitionRecordList, "countryName"),
        },
        {
          headerName: this.props.t("paymentFacilatorId"),
          field: "paymentFacilatorId"
        },
        {
          headerName: this.props.t("subMerchantId"),
          field: "subMerchantId"
        },
        {
          headerName: this.props.t("pfSubMerchantId"),
          field: "pfSubMerchantId"
        },
        {
          headerName: this.props.t("securityLevelIndicator"),
          field: "securityLevelIndicator",
          valueFormatter: params => this.getSecurityLevelNameForGrid(params, this.state.secureLevels, "desc"),
        },
        {
          headerName: this.props.t("transactionCurrency"), field: "f049",
          valueFormatter: params => this.getNameByNumericCode(params, this.props.currencyDefRecordList, "currencyName"),
        },
        {
          headerName: this.props.t("settlementCurrency"), field: "f050",
          valueFormatter: params => this.getNameByNumericCode(params, this.props.currencyDefRecordList, "currencyName"),
        },
        {
          headerName: this.props.t("preauthorizationDate"),
          field: "preauthorizationDate"
        },
        {
          headerName: this.props.t("preauthorizationClosingDateTime"),
          field: "preauthorizationClosingDateTime"
        },
        {
          headerName: this.props.t("isCapture"),
          field: "isCapture",
          cellRenderer: "booleanCellRender",
          valueFormatter: getBooleanValueCheckbox,
          filterParams: {
            valueFormatter: getBooleanValueCheckbox
          }
        },
        {
          headerName: this.props.t("paymentSource"),
          field: "paymentTransactionMethod",
        },
      ],
      recordcolumnsTransactionProvisionSettle: [
        {
          headerName: this.props.t("transactionDate"),
          field: "insertDateTime"
        },
        {
          headerName: this.props.t("orderId"),
          field: "orderId",
          cellClass: 'stringType'
        },
        {
          headerName: this.props.t("paymentId"),
          field: "paymentId",
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("bankUniqueReferenceNumber"),
          field: "bankUniqueReferenceNumber",
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("paymentStatus"),
          field: "payOutStatusGuid",
          valueFormatter: params => getListItemParameter(params, this.props.payOutStatusRecordList, "description"),
          filterParams: {
            valueFormatter: params =>
              getListItemParameter(params, this.props.payOutStatusRecordList, "description"),
          },
          valueGetter: params => getListItemParameterExcelExport(params.data.payOutStatusGuid, this.props.payOutStatusRecordList, "description") || params.data.payOutStatusGuid,
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("ravenAuthorizationResponseCodeGuid"),
          field: "ravenAuthorizationResponseCodeGuid",
          valueFormatter: params => getListItemParameter(params, this.props.ravenAuthorizationResponseCodeDefRecordList, "description"),
          filterParams: {
            valueFormatter: params =>
              getListItemParameter(params, this.props.ravenAuthorizationResponseCodeDefRecordList, "description"),
          },
          valueGetter: params => getListItemParameterExcelExport(params.data.ravenAuthorizationResponseCodeGuid, this.props.ravenAuthorizationResponseCodeDefRecordList, "description") || params.data.ravenAuthorizationResponseCodeGuid,
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("transactionNetworkGuid"), field: "transactionNetworkGuid",
          valueFormatter: params => getListItemParameter(params, this.props.transactionNetworkDefRecordList, "description"),
          valueGetter: params => getListItemParameterExcelExport(params.data.transactionNetworkGuid, this.props.transactionNetworkDefRecordList, "description") || params.data.transactionNetworkGuid,
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("transactionType"), field: "ravenTransactionTypeGuid",
          valueFormatter: params => getListItemParameter(params, this.props.ravenTransactionTypeDefRecordList, "description"),
          valueGetter: params => getListItemParameterExcelExport(params.data.ravenTransactionTypeGuid, this.props.ravenTransactionTypeDefRecordList, "description") || params.data.ravenTransactionTypeGuid,
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("cardNo"),
          field: "cardNo"
        },
        {
          headerName: this.props.t("cardTypeGuid"), field: "cardTypeGuid",
          valueFormatter: params => getListItemParameter(params, this.props.cardTypeRecordList, "description"),
          valueGetter: params => getListItemParameterExcelExport(params.data.cardTypeGuid, this.props.cardTypeRecordList, "description") || params.data.cardTypeGuid,
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("provisionStatusName"), field: "provisionStatusGuid",
          valueFormatter: params => getListItemParameter(params, this.props.provisionStatusDefRecordList, "name"),
          valueGetter: params => getListItemParameterExcelExport(params.data.provisionStatusGuid, this.props.provisionStatusDefRecordList, "name") || params.data.provisionStatusGuid,
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("preAuthAmount"),
          field: "preAuthAmount"
        },
        {
          headerName: this.props.t("installmentTypeGuid"), field: "installmentTypeGuid",
          valueFormatter: params => getListItemParameter(params, this.props.transactionInstallmentTypeRecordList, "description"),
          valueGetter: params => getListItemParameterExcelExport(params.data.installmentTypeGuid, this.props.transactionInstallmentTypeRecordList, "description") || params.data.installmentTypeGuid,
          cellClass: 'stringType'
        },
        {
          headerName: this.props.t("installmentCount"),
          field: "installmentCount"
        },
        {
          headerName: this.props.t("transactionAmount"),
          field: "f004"
        },
        {
          headerName: this.props.t("settlementAmount"),
          field: "f005"
        },
        {
          headerName: this.props.t("transactionDate"),
          field: "f013"
        },
        {
          headerName: this.props.t("posEntryMode"), field: "posEntryModeGuid",
          valueFormatter: params => getListItemParameter(params, this.props.posEntryModeRecordList, "description"),
          valueGetter: params => getListItemParameterExcelExport(params.data.posEntryModeGuid, this.props.posEntryModeRecordList, "description") || params.data.posEntryModeGuid,
          cellClass: 'stringType'
        },
        {
          headerName: this.props.t("bankName"), field: "bankGuid",
          valueFormatter: params => getListItemParameter(params, this.props.domesticBankRecordList, "bankName"),
          valueGetter: params => getListItemParameterExcelExport(params.data.bankGuid, this.props.domesticBankRecordList, "bankName") || params.data.bankGuid,
          cellClass: 'stringType'
        },
        {
          headerName: this.props.t("authorizationNumber"),
          field: "f038"
        },
        {
          headerName: this.props.t("terminalId"),
          field: "f041"
        },
        {
          headerName: this.props.t("cardAcceptorName"),
          field: "f043cardAcceptorName"
        },
        {
          headerName: this.props.t("cardAcceptorCityName"),
          field: "f043cardAcceptorCityName"
        },
        {
          headerName: this.props.t("cardAcceptorCountryCode"),
          field: "f043cardAcceptorCountryCode",
          valueFormatter: params => this.getNameByNumericCode(params, this.props.countryDefinitionRecordList, "countryName"),
        },
        {
          headerName: this.props.t("paymentFacilatorId"),
          field: "paymentFacilatorId"
        },
        {
          headerName: this.props.t("subMerchantId"),
          field: "subMerchantId"
        },
        {
          headerName: this.props.t("pfSubMerchantId"),
          field: "pfSubMerchantId"
        },
        {
          headerName: this.props.t("securityLevelIndicator"),
          field: "securityLevelIndicator",
          valueFormatter: params => this.getSecurityLevelNameForGrid(params, this.state.secureLevels, "desc"),
        },
        {
          headerName: this.props.t("transactionCurrency"),
          field: "f049",
          valueFormatter: params => this.getNameByNumericCode(params, this.props.currencyDefRecordList, "currencyName"),
        },
        {
          headerName: this.props.t("settlementCurrency"),
          field: "f050",
          valueFormatter: params => this.getNameByNumericCode(params, this.props.currencyDefRecordList, "currencyName"),
        },
        {
          headerName: this.props.t("preauthorizationDate"),
          field: "preauthorizationDate"
        },
        {
          headerName: this.props.t("preauthorizationClosingDateTime"),
          field: "preauthorizationClosingDateTime"
        },
        {
          headerName: this.props.t("isCapture"),
          field: "isCapture",
          cellRenderer: "booleanCellRender",
          valueFormatter: getBooleanValueCheckbox,
          filterParams: {
            valueFormatter: getBooleanValueCheckbox
          }
        },
        {
          headerName: this.props.t("eodDate"),
          field: "eodDate"
        },
        {
          headerName: this.props.t("paymentDate"),
          field: "paymentDate"
        },
        {
          headerName: this.props.t("batchId"),
          field: "batchId",
          cellClass: 'stringType'

        },
        {
          headerName: this.props.t("paymentSource"),
          field: "paymentTransactionMethod",
        },
      ],

    };
    this.toggle = this.toggle.bind(this);
    this.toggleSettle = this.toggleSettle.bind(this);
    this.handleDetailClick = this.handleDetailClick.bind(this);
    this.toggleCancel = this.toggleCancel.bind(this);
    this.toggleRefund = this.toggleRefund.bind(this);
  }

  //#region Base Operations
  componentDidMount() {
    this.props.doPaymentError("");
    this.props.apiError("");
    const {
      onGetRecordListTransactionProvisionSettle,
      onGetRecordListTransactionProvision,
      onGetCardBrandRecordList,
      onGetCardTypeRecordList,
      onGetPayOutStatusRecordList,
      onGetRavenTransactionTypeDefRecordList,
      onGetPosEntryModeRecordList,
      onGetRavenAuthorizationResponseCodeDefRecordList,
      onGetTerminalDefRecordList,
      onGetTransactionNetworkDefRecordList,
      onGetTransactionSourceDefRecordList,
      onGetDomesticBankList,
      onGetCurrencyRecordList,
      onGetTransactionInstallmentTypeRecordList,
      onGetProvisionStatusDefRecordList,
      onGetCountryDefinitionRecordList,
      onGetUserByUserName,

    } = this.props;
    onGetCountryDefinitionRecordList();
    onGetProvisionStatusDefRecordList();
    onGetCurrencyRecordList();
    onGetTransactionSourceDefRecordList();
    onGetTransactionNetworkDefRecordList();
    onGetTerminalDefRecordList();
    onGetRavenAuthorizationResponseCodeDefRecordList();
    onGetPosEntryModeRecordList();
    onGetRavenTransactionTypeDefRecordList();
    onGetPayOutStatusRecordList();
    onGetDomesticBankList({ userName: localStorage.getItem("username") });
    onGetCardTypeRecordList();
    onGetRecordListTransactionProvisionSettle({ userName: localStorage.getItem("username") });
    onGetRecordListTransactionProvision({ userName: localStorage.getItem("username") });
    onGetCardBrandRecordList();
    onGetTransactionInstallmentTypeRecordList();
    const username = localStorage.getItem("username");
    onGetUserByUserName(username);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      this.setState({ error: this.props.error });
    }
    if (prevProps.doPaymentApiError !== this.props.doPaymentApiError) {
      this.setState({ error: this.props.doPaymentApiError });
    }
    if (prevProps.recordListUser !== this.props.recordListUser) {
      this.props.onGetUserEncKeyByMerchantGuid(this.props.recordListUser.merchantGuid)
    }
    if(prevProps.doPaymentRecordList !== this.props.doPaymentRecordList){
      let doPaymentRecordListLength=0;
      if(this.props.doPaymentRecordList.length>0)
      {
        doPaymentRecordListLength = this.props.doPaymentRecordList.length;
      }

      if (this.props.doPaymentRecordList[doPaymentRecordListLength - 1]?.message.includes("CORE") || this.props.doPaymentRecordList[doPaymentRecordListLength - 1]?.message.includes("ISO")) {
        if (this.props.doPaymentRecordList[doPaymentRecordListLength - 1]?.message.includes("CORE")) {
          this.setState({ doPaymentResponseMessageDetail: this.props.doPaymentRecordList[doPaymentRecordListLength - 1]?.message.slice(10) })
          setTimeout(() => this.setState({ doPaymentMessage: true }), 500)
        } else if (this.props.doPaymentRecordList[doPaymentRecordListLength - 1]?.message.includes("ISO")) {
          this.setState({ doPaymentResponseMessageDetail: this.props.doPaymentRecordList[doPaymentRecordListLength - 1]?.message.slice(11) })
          setTimeout(() => this.setState({ doPaymentMessage: true }), 500)
        }

      } else {
        this.setState({ doPaymentResponseMessageDetail: this.props.doPaymentRecordList[doPaymentRecordListLength - 1]?.message })
        setTimeout(() => this.setState({ doPaymentMessage: true }), 500)
      }

    }
  }
  //#endregion

  //#region Dom Elements Design
  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
    if (this.state.modal) {
      this.setState({ isDetail: true });
    }
  }
  toggleSettle() {
    this.setState(prevState => ({ modalSettle: !prevState.modalSettle }));
    if (this.state.modalSettle) {
      this.setState({ isDetail: true });
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  toggleTabDetail(tabDetail) {
    if (this.state.activeTabDetail !== tabDetail) {
      this.setState({
        activeTabDetail: tabDetail,
      });
    }
  }
  toggleTabDetailSettle(tabDetailSettle) {
    if (this.state.activeTabDetailSettle !== tabDetailSettle) {
      this.setState({
        activeTabDetailSettle: tabDetailSettle,
      });
    }
  }
  toggleCancel() {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  }
  toggleRefund() {
    this.setState(prevState => ({ refundModal: !prevState.refundModal }));
  }

  generateRandomString = (param) => {
    const date = moment().format("SSssmmHHDDMMYY")
    const merchantId = param.selectedDataList[0].subMerchantId
    let result = '';
    const charactersLength = merchantId.length;
    for (let i = 0; i < 6; i++) {
      result += merchantId.charAt(Math.floor(Math.random() * charactersLength));
    }
    this.setState({ randomString: result + date });
  }

  showWarning = (message) => {
    this.setState({ warningMessage: message });
    setTimeout(() => this.setState({ warningModal: true }), 500);
  };

  proceedToCancel = (param) => {
    const selected = param.selectedDataList?.[0];
  
    this.generateRandomString(param);
    this.props.getApiKeyByMerchantId(selected.subMerchantId);
    this.setState({ selectedDataList: selected });
  
    if (param.selectedDataList.length === 1) {
      this.setState({ record: selected });
      this.toggleCancel();
    }
  };
  
  cancelOperation = (param) => {
    const selected = param.selectedDataList?.[0];
    if (!selected) return;
  
    const transactionCode = this.getRavenTransactionTypeName(selected.ravenTransactionTypeGuid);
    const dataDate = moment(selected.insertDateTime).format("DD");
    const nowDate = new Date().getDate().toString().padStart(2, '0');
  
    const isAuthorized = selected.ravenAuthorizationResponseCodeGuid === 1;
    const isToday = dataDate === nowDate;
    const isProvisionOrSettled = selected.provisionStatusGuid === 3 || selected.transactionSettleStatus === true;
    const isTransactionCodeBlocked = this.state.transactionCodes.some(x => x.code === transactionCode);
  
    if (!isAuthorized) {
      return this.showWarning(this.props.t("provisionStatusEqualsToVoidorTransactionSettleStatusEqualstrueCannotBeCancel"));
    }
  
    if (!isToday) {
      return this.showWarning(this.props.t("youCanOnlyCancelTodaysProvisions"));
    }
  
    if (isProvisionOrSettled || isTransactionCodeBlocked) {
      return this.showWarning(this.props.t("provisionStatusEqualsToVoidorTransactionSettleStatusEqualstrueCannotBeCancel"));
    }
  
    this.proceedToCancel(param);
  };
  
  refundOperation = param => {
    const voidStatus = "Void"
    const dataProvisionStatus = this.getProvisionStatusName(param.selectedDataList[0].provisionStatusGuid)
    let transactionCode = this.getRavenTransactionTypeName(param.selectedDataList[0].ravenTransactionTypeGuid)
    if(param.selectedDataList[0].ravenAuthorizationResponseCodeGuid == 1){
      if (this.state.transactionCodes.filter(x => x.code == transactionCode).length > 0) {
        this.setState({ warningMessage: this.props.t("refundCanBeOnlySales") })
        setTimeout(() => this.setState({ warningModal: true }), 500)
      } else {
        if(dataProvisionStatus == voidStatus){
          this.setState({ warningMessage: this.props.t("refundCanBeOnlySales") })
          setTimeout(() => this.setState({ warningModal: true }), 500)
        }else{
          this.generateRandomString(param);
          this.props.getApiKeyByMerchantId(param.selectedDataList[0].subMerchantId)
          this.setState({ selectedDataList: param.selectedDataList[0], })
          if (param.selectedDataList.length == 1) {
            this.setState({
              record: param.selectedDataList[0],
            });
            this.toggleRefund();
          }
        }
        
  
      }
    }else{
      this.setState({ warningMessage: this.props.t("refundCanBeOnlySales") })
        setTimeout(() => this.setState({ warningModal: true }), 500)
    }
   

  }



  //#endregion

  handleDetailClick = values => {
    this.setState({
      record: values,
      isDetail: true,
    });

    this.toggleTabDetail("1");
    this.toggle();
  };

  handleDetailClickSettle = values => {
    this.props.onGetMerchantPaymentDetailByTransactionProvisionSettleGuid(values.guid);

    this.setState({
      record: values,
      isDetail: true,
    });

    this.toggleTabDetailSettle("1");
    this.toggleSettle();
  };

  SearchContentTransactionProvision = () => {
    return <SearchContentTransactionProvision />;
  }

  SearchContentTransactionProvisionSettle = () => {
    return <SearchContentTransactionProvisionSettle />;
  }

  getPreAuthClosingAmountValue = () => {
    if (this.state.record.preauthorizationClosingDateTime) {
      return this.state.record.preAuthAmount
    } else {
      return null
    }
  }

  valueOfIsCancel = () => {
    if (this.state.record.provisionStatusGuid == 3 || this.state.record.provisionStatusGuid == "3") {
      return true
    } else {
      return false
    }
  }

  getSecurityLevelNameForGrid(params, list, parameter) {
    if (list) {
      let cmbObject = list.filter(
        x => x.guid == params.value
      );
      let opts = cmbObject[0];
      let param = opts != undefined ? opts[parameter] : "";
      return cmbObject.length > 0 && param ? param : params.value;
    } else {
      return params.value;
    }
  }
  getSecurityLevelString(value) {
    if (value === "2") {
      return "Full Secure";
    } else if (value === "1") {
      return "Half Secure";
    } else if (value === "0") {
      return "None Secure";
    } else {
      return "";
    }
  }
  getBankName(bankGuid) {
    let array = this.props.domesticBankRecordList
      .filter(i => i.guid === bankGuid)
      .map(x => x);

    if (array?.length) return array[0].bankName;
    else return bankGuid;
  }

  getInstallmentTypeName(installmentGuid) {
    let array = this.props.transactionInstallmentTypeRecordList
      .filter(i => i.guid === installmentGuid)
      .map(x => x);

    if (array?.length) return array[0].name;
    else return installmentGuid;
  }

  getPosEntryModeName(posEntryGuid) {
    let array = this.props.posEntryModeRecordList
      .filter(i => i.guid === posEntryGuid)
      .map(x => x);

    if (array?.length) return array[0].name;
    else return posEntryGuid;
  }

  getProvisionStatusName(provStatGuid) {
    let array = this.props.provisionStatusDefRecordList
      .filter(i => i.guid === provStatGuid)
      .map(x => x);

    if (array?.length) return array[0].name;
    else return provStatGuid;
  }

  getNameByNumericCode(params, list, parameter) {
    if (list) {
      let cmbObject = list.filter(
        x => x.numericCode == params.value
      );

      let opts = cmbObject[0];
      let param = opts != undefined ? opts[parameter] : "";
      return cmbObject.length > 0 && param ? param : params.value;
    } else {
      return params.value;
    }
  }

  getCardTypeName(cardTypeGuid) {
    let array = this.props.cardTypeRecordList
      .filter(i => i.guid === cardTypeGuid)
      .map(x => x);

    if (array?.length) return array[0].name;
    else return cardTypeGuid;
  }

  getPaymentStatusName(payOutStatusGuid) {
    let array = this.props.payOutStatusRecordList
      .filter(i => i.guid === payOutStatusGuid)
      .map(x => x);

    if (array?.length) return array[0].name;
    else return payOutStatusGuid;
  }

  getRavenTransactionTypeName(ravenTransactionTypeGuid) {
    let array = this.props.ravenTransactionTypeDefRecordList
      .filter(i => i.guid === ravenTransactionTypeGuid)
      .map(x => x);

    if (array?.length) return array[0].description;
    else return ravenTransactionTypeGuid;
  }

  getCurrencyName(currencyNumericCode) {
    let array = this.props.currencyDefRecordList
      .filter(i => i.numericCode === currencyNumericCode)
      .map(x => x);

    if (array?.length) return array[0].currencyName;
    else return currencyNumericCode;
  }

  getPayFacCommissionAmount(recordGuid) {
    let array = this.props.merchantPaymentDetailRecordList
      .filter(i => i.transactionProvisionSettleGuid === recordGuid)
      .map(x => x);
    if (array?.length) return array[0].transactionProvisionSettle.payFacCommissionAmount;
    else return null;
  }

  getPayFacCommissionRate(recordGuid) {
    let array = this.props.merchantPaymentDetailRecordList
      .filter(i => i.transactionProvisionSettleGuid === recordGuid)
      .map(x => x);
    if (array?.length) return array[0].transactionProvisionSettle.payFacCommissionRate;
    else return null;
  }

  getCountryName(countryNumericCode) {
    let array = this.props.countryDefinitionRecordList
      .filter(i => i.numericCode === countryNumericCode)
      .map(x => x);

    if (array?.length) return array[0].countryName;
    else return countryNumericCode;
  }

  getTransactionNetworkName(networkGuid) {
    let array = this.props.transactionNetworkDefRecordList
      .filter(i => i.guid === networkGuid)
      .map(x => x);

    if (array?.length) return array[0].name;
    else return networkGuid;
  }

  render() {
    const styles = {
      border: '2px solid rgba(0, 0, 0, 0.08)',
    };
    const { recordListTransactionProvisionSettle, recordListTransactionProvision } = this.props;
    const { error, recordcolumnsTransactionProvision, doPaymentResponseMessageDetail,recordcolumnsTransactionProvisionSettle, record, warningModal, warningMessage,doPaymentMessage } = this.state;
    const DropDownOperations = [
      {
        func: this.refundOperation,
        operationName: this.props.t("refundOperations"),
      },
      {
        func: this.cancelOperation,
        operationName: this.props.t("cancelOperation"),
      },
    ];
    const DropDownOperationsSettle = [
      {
        func: this.refundOperation,
        operationName: this.props.t("refundOperations"),
      }
    ];
    return (
      <React.Fragment>
        {error && (<ErrorModal errorMessage={error} onCloseModalClick={() => this.setState({ error: undefined })} />)}
        <ToastContainer />
        <WarningModal
          warningMessage={warningMessage}
          show={warningModal}
          onCloseClick={() => this.setState({ warningModal: false })}
        />
         {doPaymentMessage && (
          <MessageBoxModal
            messageText={"Response"}
            messageDetailText={doPaymentResponseMessageDetail}
            show={doPaymentMessage}
            onCloseClick={() => this.setState({ doPaymentMessage: false })}
          />
        )}
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xl={12} lg={12}>
                <Card>
                  <ul
                    className="nav nav-tabs nav-tabs-custom justify-content-left pt-2"
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        to="#"
                        className={classnames({
                          active: this.state.activeTab === "1",
                        })}
                        onClick={() => {
                          this.toggleTab("1");
                        }}
                      >
                        {this.props.t("transactionProvision")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        to="#"
                        className={classnames({
                          active: this.state.activeTab === "2",
                        })}
                        onClick={() => {
                          this.toggleTab("2");
                        }}
                      >
                        {this.props.t("transactionProvisionSettle")}
                      </NavLink>
                    </NavItem>
                  </ul>
                  <TabContent className="p-4" activeTab={this.state.activeTab}>
                    <TabPane tabId="1" id="all-post">
                      <Row>
                        <Col xs="12">
                          <RavenAgSelectable
                            DropdownItems={DropDownOperations}
                            onDetailClick={this.handleDetailClick}
                            actionItems={true}
                            exportOption={true}
                            recordcolumns={recordcolumnsTransactionProvision}
                            recordList={recordListTransactionProvision}
                            SearchContent={this.SearchContentTransactionProvision}
                            statusBar={true}
                            singleSelection={true}
                          />
                          <Modal
                            isOpen={this.state.refundModal}
                            className={this.props.className}
                            onClose={this.toggleModalClose}
                            size="xl"
                            backdrop={"static"}
                            id="staticBackdrop"
                          >
                            <ModalHeader
                              toggle={this.toggleRefund}
                              tag="h4"
                            >
                              {this.props.t("refundOperations")}
                            </ModalHeader>
                            <ModalBody>
                              <DoPaymentRefundOperations
                                record={this.state.record}
                                isDetail={this.state.isDetail}
                                currencyDefRecordList={this.props.currencyDefRecordList}
                                toggle={this.toggleRefund}
                                recordListByMerchantGuid={this.props.recordListEncKey}
                                randomString={this.state.randomString}
                                recordListSignRefund={this.props.recordListSignRefund}
                                selectedDataList={this.state.selectedDataList}
                                doPaymentSignRefund={this.props.doPaymentSignRefund}
                              />
                            </ModalBody>
                          </Modal>
                          <Modal
                            isOpen={this.state.cancelModal}
                            className={this.props.className}
                            onClose={this.toggleModalClose}
                            size="xl"
                            backdrop={"static"}
                            id="staticBackdrop"
                          >
                            <ModalHeader
                              toggle={this.toggleCancel}
                              tag="h4"
                            >
                              {this.props.t("cancelOperation")}
                            </ModalHeader>
                            <ModalBody>
                              <DoPaymentVoidOperation
                                record={this.state.record}
                                isDetail={this.state.isDetail}
                                currencyDefRecordList={this.props.currencyDefRecordList}
                                toggle={this.toggleCancel}
                                recordListByMerchantGuid={this.props.recordListEncKey}
                                randomString={this.state.randomString}
                                recordListSign={this.props.recordListSign}
                                selectedDataList={this.state.selectedDataList}
                                doPaymentSignVoid={this.props.doPaymentSignVoid}
                              />
                            </ModalBody>
                          </Modal>
                          <Modal
                            isOpen={this.state.modal}
                            className={this.props.className}
                            onClose={this.toggleModalClose}
                            size="xl"
                            backdrop={"static"}
                            id="staticBackdrop">
                            <ModalHeader toggle={this.toggle} tag="h4">
                              {getTitleValue(this, this.props.t("transactionMonitoring"))}
                            </ModalHeader>
                            <Col xs="12">
                              <ul
                                className="nav nav-tabs nav-tabs-custom justify-content-left pt-2"
                                role="tablist"
                              >
                                <NavItem>
                                  <NavLink
                                    to="#"
                                    className={classnames({
                                      active: this.state.activeTabDetail === "1",
                                    })}
                                    onClick={() => {
                                      this.toggleTabDetail("1");
                                    }}
                                  >
                                    {this.props.t("generalTransactionInfo")}
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    to="#"
                                    className={classnames({
                                      active: this.state.activeTabDetail === "2",
                                    })}
                                    onClick={() => {
                                      this.toggleTabDetail("2");
                                    }}
                                  >
                                    {this.props.t("dateAmountInfo")}
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    to="#"
                                    className={classnames({
                                      active: this.state.activeTabDetail === "3",
                                    })}
                                    onClick={() => {
                                      this.toggleTabDetail("3");
                                    }}
                                  >
                                    {this.props.t("merchantInfo")}
                                  </NavLink>
                                </NavItem>
                              </ul>
                              <TabContent className="p-4 pb-0" activeTab={this.state.activeTabDetail}>
                                <TabPane tabId="1" id="all-post">
                                  <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                      f038: getInitValue(record, record.f038),
                                      orderId: getInitValue(record, record.orderId),
                                      paymentId: getInitValue(record, record.paymentId),
                                      bankUniqueReferenceNumber: getInitValue(record, record.bankUniqueReferenceNumber),
                                      ravenTransactionTypeDescription: this.getRavenTransactionTypeName(record.ravenTransactionTypeGuid),
                                      cardNo: getInitValueNull(record, record.cardNo),
                                      f032: this.getBankName(record.bankGuid),
                                      cardTypeName: this.getCardTypeName(record.cardTypeGuid),
                                      posEntryModeName: this.getPosEntryModeName(record.posEntryModeGuid),
                                      securityLevelIndicator: getInitValue(record, record.securityLevelIndicator),
                                      installmentTypeDescription: this.getInstallmentTypeName(record.installmentTypeGuid),
                                      installmentCount: getInitValue(record, record.installmentCount),
                                      provisionStatusName: this.getProvisionStatusName(record.provisionStatusGuid),
                                      transactionNetworkName: this.getTransactionNetworkName(record.transactionNetworkGuid),
                                      isCancel: this.valueOfIsCancel(),
                                      transactionSettleStatus: getInitValueBoolean(record, record.transactionSettleStatus),
                                      isCapture:getInitValueBoolean(record,record.isCapture),
                                    }}

                                    validationSchema={Yup.object().shape({
                                    })}
                                  >
                                    {({ errors, touched, setFieldValue }) => (
                                      <Form>
                                        <fieldset disabled={this.state.isDetail}>
                                          <Row style={{ padding: "0" }}>
                                            <Card style={styles}>
                                              <CardBody>
                                                <Row>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f038"}
                                                        label={this.props.t("authorizationNumber")}
                                                        type="text"
                                                        setFieldValue={setFieldValue}
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"orderId"}
                                                        label={this.props.t("orderId")}
                                                        type="text"
                                                        setFieldValue={setFieldValue}
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"paymentId"}
                                                        label={this.props.t("paymentId")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"bankUniqueReferenceNumber"}
                                                        label={this.props.t("bankUniqueReferenceNumber")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"ravenTransactionTypeDescription"}
                                                        label={this.props.t("transactionType")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"cardNo"}
                                                        label={this.props.t("cardNumber")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f032"}
                                                        label={this.props.t("bankName")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"installmentCount"}
                                                      label={this.props.t("installmentCount")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"cardTypeName"}
                                                      label={this.props.t("cardType")}
                                                      type="text"
                                                      setFieldValue={setFieldValue}
                                                    />
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"securityLevelIndicator"}
                                                       value={this.getSecurityLevelString(record.securityLevelIndicator)}
                                                      label={this.props.t("securityLevelIndicator")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"posEntryModeName"}
                                                      label={this.props.t("posEntryMode")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"installmentTypeDescription"}
                                                      label={this.props.t("installmentType")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                </Row>
                                                <Row>

                                                  <Col lg={3} className="col-4">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"provisionStatusName"}
                                                        label={this.props.t("provisionStatus")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"transactionNetworkName"}
                                                        label={this.props.t("transactionNetwork")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3} className="col-4">
                                                    <div className="mb-3">
                                                      <TransactionMonitoringBoxSingle
                                                        BoxName={this.props.t("cancel")}
                                                        fieldName={"isCancel"}
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <TransactionMonitoringBoxSingle
                                                        BoxName={this.props.t("isCapture")}
                                                        fieldName="isCapture"
                                                        value={
                                                          record.isCapture
                                                        }
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </CardBody>
                                            </Card>
                                          </Row>
                                        </fieldset>
                                      </Form>
                                    )}
                                  </Formik>
                                </TabPane>
                                <TabPane tabId="2" id="all-post">
                                  <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                      f013: getInitValueNull(record, record.f013),
                                      insertDateTime: getInitValueNull(record, record.insertDateTime),
                                      preauthorizationDate: getInitValueNull(record, record.preauthorizationDate),
                                      reverseDateTime: getInitValueNull(record, record.reverseDateTime),
                                      preauthorizationClosingDateTime: getInitValueNull(record, record.preauthorizationClosingDateTime),
                                      f004: getInitValueNull(record, record.f004),
                                      f005: getInitValueNull(record, record.f005),
                                      transactionCurrencyName: this.getCurrencyName(record.f049),
                                      clearingCurrencyName: this.getCurrencyName(record.f050),
                                      preAuthAmount: getInitValueNull(record, record.preAuthAmount),
                                    }}
                                    validationSchema={Yup.object().shape({
                                    })}
                                  >
                                    {({ errors, touched }) => (
                                      <Form>
                                        <fieldset disabled={this.state.isDetail}>
                                          <Row style={{ padding: "0" }}>
                                            <Card style={styles}>
                                              <CardBody>
                                                <Row>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"insertDateTime"}
                                                        label={this.props.t("transactionDate")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"preauthorizationClosingDateTime"}
                                                        label={this.props.t("preauthorizationClosingDate")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"reverseDateTime"}
                                                        label={this.props.t("reverseDateTime")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f004"}
                                                        label={this.props.t("transactionAmount")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"preAuthAmount"}
                                                      label={this.props.t("preauthorizationAmount")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f005"}
                                                        label={this.props.t("settlementAmount")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"transactionCurrencyName"}
                                                        label={this.props.t("transactionCurrency")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>

                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"clearingCurrencyName"}
                                                      label={this.props.t("settlementCurrency")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                </Row>
                                              </CardBody>
                                            </Card>
                                          </Row>
                                        </fieldset>
                                      </Form>
                                    )}
                                  </Formik>
                                </TabPane>
                                <TabPane tabId="3" id="all-post">
                                  <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                      f043cardAcceptorName: getInitValue(record, record.f043cardAcceptorName),
                                      f041: getInitValue(record, record.f041),
                                      f043cardAcceptorCityName: getInitValue(record, record.f043cardAcceptorCityName),
                                      f043cardAcceptorCountryCode: this.getCountryName(record.f043cardAcceptorCountryCode),
                                      subMerchantId: getInitValue(record, record.subMerchantId),
                                    }}
                                    validationSchema={Yup.object().shape({
                                    })}
                                  >
                                    {({ errors, touched }) => (
                                      <Form>
                                        <fieldset disabled={this.state.isDetail}>
                                          <Row style={{ padding: "0" }}>
                                            <Card style={styles}>
                                              <CardBody>
                                                <Row>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f043cardAcceptorName"}
                                                        label={this.props.t("cardAcceptorName")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f041"}
                                                        label={this.props.t("terminalId")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f043cardAcceptorCityName"}
                                                        label={this.props.t("cardAcceptorCityName")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f043cardAcceptorCountryCode"}
                                                        label={this.props.t("cardAcceptorCountryName")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"subMerchantId"}
                                                        label={this.props.t("subMerchantId")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </CardBody>
                                            </Card>
                                          </Row>
                                        </fieldset>
                                      </Form>
                                    )}
                                  </Formik>
                                </TabPane>
                              </TabContent>
                            </Col>
                          </Modal>

                        </Col>
                      </Row>
                    </TabPane>

                    <TabPane tabId="2">
                      <Row>
                        <Col xs="12">
                          <RavenAgSelectable
                            DropdownItems={DropDownOperationsSettle}
                            onDetailClick={this.handleDetailClickSettle}
                            actionItems={true}
                            exportOption={true}
                            recordcolumns={recordcolumnsTransactionProvisionSettle}
                            recordList={recordListTransactionProvisionSettle}
                            SearchContent={this.SearchContentTransactionProvisionSettle}
                            statusBar={true}
                            singleSelection={true}
                          />
                          <Modal
                            isOpen={this.state.modalSettle}
                            className={this.props.className}
                            onClose={this.toggleModalClose}
                            size="xl"
                            backdrop={"static"}
                            id="staticBackdrop">
                            <ModalHeader toggle={this.toggleSettle} tag="h4">
                              {getTitleValue(this, this.props.t("transactionMonitoring"))}
                            </ModalHeader>
                            <Col xs="12">
                              <ul
                                className="nav nav-tabs nav-tabs-custom justify-content-left pt-2"
                                role="tablist"
                              >
                                <NavItem>
                                  <NavLink
                                    to="#"
                                    className={classnames({
                                      active: this.state.activeTabDetailSettle === "1",
                                    })}
                                    onClick={() => {
                                      this.toggleTabDetailSettle("1");
                                    }}
                                  >
                                    {this.props.t("generalTransactionInfo")}
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    to="#"
                                    className={classnames({
                                      active: this.state.activeTabDetailSettle === "2",
                                    })}
                                    onClick={() => {
                                      this.toggleTabDetailSettle("2");
                                    }}
                                  >
                                    {this.props.t("dateAmountInfo")}
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    to="#"
                                    className={classnames({
                                      active: this.state.activeTabDetailSettle === "3",
                                    })}
                                    onClick={() => {
                                      this.toggleTabDetailSettle("3");
                                    }}
                                  >
                                    {this.props.t("merchantInfo")}
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    to="#"
                                    className={classnames({
                                      active: this.state.activeTabDetailSettle === "4",
                                    })}
                                    onClick={() => {
                                      this.toggleTabDetailSettle("4");
                                    }}
                                  >
                                    {this.props.t("commissionInfo")}
                                  </NavLink>
                                </NavItem>
                              </ul>
                              <TabContent className="p-4 pb-0" activeTab={this.state.activeTabDetailSettle}>
                                <TabPane tabId="1" id="all-post">
                                  <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                      f038: getInitValue(record, record.f038),
                                      orderId: getInitValue(record, record.orderId),
                                      paymentId: getInitValue(record, record.paymentId),
                                      bankUniqueReferenceNumber: getInitValue(record, record.bankUniqueReferenceNumber),
                                      ravenTransactionTypeDescription: this.getRavenTransactionTypeName(record.ravenTransactionTypeGuid),
                                      cardNo: getInitValueNull(record, record.cardNo),
                                      f032: this.getBankName(record.bankGuid),
                                      cardTypeName: this.getCardTypeName(record.cardTypeGuid),
                                      posEntryModeName: this.getPosEntryModeName(record.posEntryModeGuid),
                                      securityLevelIndicator: getInitValue(record, record.securityLevelIndicator),
                                      installmentTypeDescription: this.getInstallmentTypeName(record.installmentTypeGuid),
                                      installmentCount: getInitValue(record, record.installmentCount),
                                      provisionStatusName: this.getProvisionStatusName(record.provisionStatusGuid),
                                      transactionNetworkName: this.getTransactionNetworkName(record.transactionNetworkGuid),
                                      transactionSettleStatus: getInitValueBoolean(record, record.transactionSettleStatus),
                                      paymentStatus: this.getPaymentStatusName(record.payOutStatusGuid),
                                      isCapture:getInitValueBoolean(record,record.isCapture),
                                    }}

                                    validationSchema={Yup.object().shape({
                                    })}
                                  >
                                    {({ errors, touched, setFieldValue }) => (
                                      <Form>
                                        <fieldset disabled={this.state.isDetail}>
                                          <Row style={{ padding: "0" }}>
                                            <Card style={styles}>
                                              <CardBody>
                                                <Row>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f038"}
                                                        label={this.props.t("authorizationNumber")}
                                                        type="text"
                                                        setFieldValue={setFieldValue}
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"orderId"}
                                                        label={this.props.t("orderId")}
                                                        type="text"
                                                        setFieldValue={setFieldValue}
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"paymentId"}
                                                        label={this.props.t("paymentId")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"bankUniqueReferenceNumber"}
                                                        label={this.props.t("bankUniqueReferenceNumber")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"ravenTransactionTypeDescription"}
                                                        label={this.props.t("ravenTransactionType")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"cardNo"}
                                                        label={this.props.t("cardNumber")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f032"}
                                                        label={this.props.t("bankName")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"installmentCount"}
                                                      label={this.props.t("installmentCount")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"cardTypeName"}
                                                      label={this.props.t("cardType")}
                                                      type="text"
                                                      setFieldValue={setFieldValue}
                                                    />
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"securityLevelIndicator"}
                                                      value={this.getSecurityLevelString(record.securityLevelIndicator)}
                                                      label={this.props.t("securityLevelIndicator")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"posEntryModeName"}
                                                      label={this.props.t("posEntryMode")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"installmentTypeDescription"}
                                                      label={this.props.t("installmentType")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"paymentStatus"}
                                                      label={this.props.t("paymentStatus")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"provisionStatusName"}
                                                        label={this.props.t("provisionStatus")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"transactionNetworkName"}
                                                        label={this.props.t("transactionNetwork")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <TransactionMonitoringBoxSingle
                                                        BoxName={this.props.t("isCapture")}
                                                        fieldName="isCapture"
                                                        value={
                                                          record.isCapture
                                                        }
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </CardBody>
                                            </Card>
                                          </Row>
                                        </fieldset>
                                      </Form>
                                    )}
                                  </Formik>
                                </TabPane>
                                <TabPane tabId="2" id="all-post">
                                  <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                      f013: getInitValueNull(record, record.f013),
                                      insertDateTime: getInitValueNull(record, record.insertDateTime),
                                      eodDate: getInitValueNull(record, record.eodDate),
                                      preauthorizationDate: getInitValueNull(record, record.preauthorizationDate),
                                      preauthorizationClosingDateTime: getInitValueNull(record, record.preauthorizationClosingDateTime),
                                      reverseDateTime: getInitValueNull(record, record.reverseDateTime),
                                      f004: getInitValueNull(record, record.f004),
                                      f005: getInitValueNull(record, record.f005),
                                      transactionCurrencyName: this.getCurrencyName(record.f049),
                                      clearingCurrencyName: this.getCurrencyName(record.f050),
                                      preAuthAmount: getInitValueNull(record, record.preAuthAmount),
                                      paymentDate: getInitValueNull(record, record.paymentDate)
                                    }}
                                    validationSchema={Yup.object().shape({
                                    })}
                                  >
                                    {({ errors, touched }) => (
                                      <Form>
                                        <fieldset disabled={this.state.isDetail}>
                                          <Row style={{ padding: "0" }}>
                                            <Card style={styles}>
                                              <CardBody>
                                                <Row>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"insertDateTime"}
                                                        label={this.props.t("transactionDate")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"eodDate"}
                                                        label={this.props.t("eodDate")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  {/* <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"preauthorizationClosingDateTime"}
                                                        label={this.props.t("preauthorizationClosingDate")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col> */}
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"paymentDate"}
                                                      label={this.props.t("paymentDate")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"reverseDateTime"}
                                                        label={this.props.t("reverseDateTime")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f004"}
                                                        label={this.props.t("transactionAmount")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"transactionCurrencyName"}
                                                        label={this.props.t("transactionCurrency")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f005"}
                                                        label={this.props.t("settlementAmount")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"clearingCurrencyName"}
                                                      label={this.props.t("settlementCurrency")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"preAuthAmount"}
                                                      label={this.props.t("preauthorizationAmount")}
                                                      type="text"
                                                    />
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"preauthorizationClosingDateTime"}
                                                        label={this.props.t("preauthorizationClosingDate")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  {/* <Col lg={3} className="col-4">
                                                    <RavenFormikField
                                                      errors={errors}
                                                      touched={touched}
                                                      name={"paymentDate"}
                                                      label={this.props.t("paymentDate")}
                                                      type="text"
                                                    />
                                                  </Col> */}
                                                </Row>
                                              </CardBody>
                                            </Card>
                                          </Row>
                                        </fieldset>
                                      </Form>
                                    )}
                                  </Formik>
                                </TabPane>
                                <TabPane tabId="3" id="all-post">
                                  <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                      f043cardAcceptorName: getInitValue(record, record.f043cardAcceptorName),
                                      f041: getInitValue(record, record.f041),
                                      f043cardAcceptorCityName: getInitValue(record, record.f043cardAcceptorCityName),
                                      f043cardAcceptorCountryCode: this.getCountryName(record.f043cardAcceptorCountryCode),
                                      subMerchantId: getInitValue(record, record.subMerchantId),
                                    }}
                                    validationSchema={Yup.object().shape({
                                    })}
                                  >
                                    {({ errors, touched }) => (
                                      <Form>
                                        <fieldset disabled={this.state.isDetail}>
                                          <Row style={{ padding: "0" }}>
                                            <Card style={styles}>
                                              <CardBody>
                                                <Row>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f043cardAcceptorName"}
                                                        label={this.props.t("cardAcceptorName")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f041"}
                                                        label={this.props.t("terminalId")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f043cardAcceptorCityName"}
                                                        label={this.props.t("cardAcceptorCityName")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"f043cardAcceptorCountryCode"}
                                                        label={this.props.t("cardAcceptorCountryName")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"subMerchantId"}
                                                        label={this.props.t("subMerchantId")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </CardBody>
                                            </Card>
                                          </Row>
                                        </fieldset>
                                      </Form>
                                    )}
                                  </Formik>
                                </TabPane>
                                <TabPane tabId="4" id="all-post">
                                  <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                      payFacCommissionAmount: this.getPayFacCommissionAmount(record.guid),
                                      payFacCommissionRate: this.getPayFacCommissionRate(record.guid)
                                    }}
                                    validationSchema={Yup.object().shape({
                                    })}
                                  >
                                    {({ errors, touched }) => (
                                      <Form>
                                        <fieldset disabled={this.state.isDetail}>
                                          <Row style={{ padding: "0" }}>
                                            <Card style={styles}>
                                              <CardBody>
                                                <Row>
                                                  <Col lg={3}>
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"payFacCommissionAmount"}
                                                        label={this.props.t("payFacCommissionAmount")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg={3} className="col-6">
                                                    <div className="mb-3">
                                                      <RavenFormikField
                                                        errors={errors}
                                                        touched={touched}
                                                        name={"payFacCommissionRate"}
                                                        label={this.props.t("payFacCommissionRate")}
                                                        type="text"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </CardBody>
                                            </Card>
                                          </Row>
                                        </fieldset>
                                      </Form>
                                    )}
                                  </Formik>
                                </TabPane>
                              </TabContent>
                            </Col>
                          </Modal>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment >
    );
  }
}

transactionMonitoring.propTypes = {
  recordListTransactionProvisionSettle: PropTypes.array,
  onGetRecordListTransactionProvisionSettle: PropTypes.func,
  onGetRecordListTransactionProvision: PropTypes.func,
  recordListTransactionProvision: PropTypes.array,
  className: PropTypes.any,
  apiError: PropTypes.func,
  doPaymentError: PropTypes.func,
  doPaymentApiError: PropTypes.any,
  t: PropTypes.any,
  error: PropTypes.any,
  onGetCardBrandRecordList: PropTypes.func,
  cardBrandRecordList: PropTypes.array,
  cardTypeRecordList: PropTypes.array,
  onGetCardTypeRecordList: PropTypes.func,
  payOutStatusRecordList: PropTypes.array,
  onGetPayOutStatusRecordList: PropTypes.func,
  ravenTransactionTypeDefRecordList: PropTypes.array,
  onGetRavenTransactionTypeDefRecordList: PropTypes.func,
  posEntryModeRecordList: PropTypes.array,
  onGetPosEntryModeRecordList: PropTypes.func,
  ravenAuthorizationResponseCodeDefRecordList: PropTypes.array,
  onGetRavenAuthorizationResponseCodeDefRecordList: PropTypes.func,
  terminalDefRecordList: PropTypes.array,
  onGetTerminalDefRecordList: PropTypes.func,
  onGetTransactionNetworkDefRecordList: PropTypes.func,
  transactionNetworkDefRecordList: PropTypes.array,
  onGetTransactionSourceDefRecordList: PropTypes.func,
  transactionSourceDefRecordList: PropTypes.array,
  onGetDomesticBankList: PropTypes.func,
  domesticBankRecordList: PropTypes.array,
  onGetCurrencyRecordList: PropTypes.func,
  currencyDefRecordList: PropTypes.array,
  onGetTransactionInstallmentTypeRecordList: PropTypes.func,
  transactionInstallmentTypeRecordList: PropTypes.array,
  provisionStatusDefRecordList: PropTypes.array,
  onGetProvisionStatusDefRecordList: PropTypes.func,
  countryDefinitionRecordList: PropTypes.array,
  onGetCountryDefinitionRecordList: PropTypes.func,
  onGetMerchantPaymentDetailByTransactionProvisionSettleGuid: PropTypes.func,
  merchantPaymentDetailRecordList: PropTypes.array,
  doPaymentSignVoid: PropTypes.func,
  doPaymentSignRefund: PropTypes.func,
  recordListSignRefund: PropTypes.array,
  recordListSign: PropTypes.array,
  getApiKeyByMerchantId: PropTypes.func,
  recordListByMerchantId: PropTypes.array,
  onGetUserEncKeyByMerchantGuid: PropTypes.func,
  onGetUserByUserName: PropTypes.func,
  recordListUser: PropTypes.array,
  recordListEncKey: PropTypes.any,
  doPaymentRecordList:PropTypes.array
};

const mapStateToProps = ({
  transactionProvisionSettle,
  cardBrandDef, cardTypeDef,
  payOutStatusDef,
  ravenTransactionTypeDef,
  PosEntryMode,
  ravenAuthorizationResponseCodeDef,
  terminalDef,
  transactionNetworkDef,
  transactionSourceDef,
  domesticBankDefinition,
  currencyDefinition,
  transactionProvision,
  transactionInstallmentTypeDef,
  provisionStatusDef,
  countryDefinition,
  merchantPaymentDetail,
  doPayment,
  UserDefinition
}) => ({
  merchantPaymentDetailRecordList: merchantPaymentDetail.recordList,
  countryDefinitionRecordList: countryDefinition.recordList,
  provisionStatusDefRecordList: provisionStatusDef.recordList,
  transactionInstallmentTypeRecordList: transactionInstallmentTypeDef.recordList,
  currencyDefRecordList: currencyDefinition.recordList,
  domesticBankRecordList: domesticBankDefinition.recordList,
  transactionSourceDefRecordList: transactionSourceDef.recordList,
  transactionNetworkDefRecordList: transactionNetworkDef.recordList,
  terminalDefRecordList: terminalDef.recordList,
  ravenAuthorizationResponseCodeDefRecordList: ravenAuthorizationResponseCodeDef.recordList,
  posEntryModeRecordList: PosEntryMode.recordList,
  ravenTransactionTypeDefRecordList: ravenTransactionTypeDef.recordList,
  payOutStatusRecordList: payOutStatusDef.recordList,
  cardTypeRecordList: cardTypeDef.recordList,
  cardBrandRecordList: cardBrandDef.recordList,
  recordListTransactionProvisionSettle: transactionProvisionSettle.recordList,
  recordListTransactionProvision: transactionProvision.recordList,
  recordListSign: doPayment.recordListSing,
  recordListByMerchantId: UserDefinition.recordListByMerchantId,
  error: transactionProvisionSettle.error,
  recordListUser: UserDefinition.recordListUser,
  recordListEncKey: UserDefinition.recordListUserEncKey,
  recordListSignRefund: doPayment.recordListSignRefund,
  doPaymentApiError: doPayment.error,
  doPaymentRecordList:doPayment.recordList


});

const mapDispatchToProps = dispatch => ({
  onGetMerchantPaymentDetailByTransactionProvisionSettleGuid: guid => dispatch(getMerchantPaymentDetailByTransactionProvisionSettleGuid(guid)),
  onGetCountryDefinitionRecordList: () => dispatch(getCountryList()),
  onGetProvisionStatusDefRecordList: () => dispatch(getProvisionStatusDefList()),
  onGetTransactionInstallmentTypeRecordList: () => dispatch(getTransactionInstallmentTypeDefList()),
  onGetCurrencyRecordList: () => dispatch(getCurrencyList()),
  onGetTransactionSourceDefRecordList: () => dispatch(getTransactionSourceDefList()),
  onGetTransactionNetworkDefRecordList: () => dispatch(getTransactionNetworkDefList()),
  onGetTerminalDefRecordList: () => dispatch(getTerminalDefList()),
  onGetRavenAuthorizationResponseCodeDefRecordList: () => dispatch(getRavenAuthorizationResponseCodeDefList()),
  onGetPosEntryModeRecordList: () => dispatch(getPosEntryModeList()),
  onGetRavenTransactionTypeDefRecordList: () => dispatch(getRavenTransactionTypeDefList()),
  onGetPayOutStatusRecordList: () => dispatch(getPayOutStatusDefList()),
  onGetCardTypeRecordList: () => dispatch(getCardTypeDefList()),
  onGetRecordListTransactionProvisionSettle: (record) => dispatch(getTransactionProvisionSettleList(record)),
  onGetRecordListTransactionProvision: (record) => dispatch(getTransactionProvisionList(record)),
  onGetCardBrandRecordList: () => dispatch(getCardBrandDefList()),
  onGetDomesticBankList: (record) => dispatch(getDomesticBankList(record)),
  apiError: error => dispatch(transactionProvisionSettleApiError(error)),
  doPaymentSignVoid: (record) => dispatch(doPaymentSignVoid(record)),
  doPaymentSignRefund: (record) => dispatch(doPaymentSignRefund(record)),
  getApiKeyByMerchantId: (record) => dispatch(getApiKeyByMerchantId(record)),
  onGetUserEncKeyByMerchantGuid: record => dispatch(getUserEncKeyByMerchantGuid(record)),
  onGetUserByUserName: userName => dispatch(getUserByUserName(userName)),
  doPaymentError: error => dispatch(doPaymentApiError(error))


});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(transactionMonitoring));